import React, { Component } from 'react';
import qs from "qs";
import { Modal, Button } from 'antd-mobile';
import './index.less';
import { getAllMaterial } from 'apis/material';






export default class CountdownModal extends Component {
  constructor(props) {
    super(props);
    const { phoneNumber, info } = this.props;
    this.state = {
      info: info,
      phoneNumber: phoneNumber,
      visible: false,
      countdown: 5, // 倒计时时间
      isCounting: true, // 是否正在倒计时
      countDownTextShow: "inline-block"
    };

  }
  // 日期格式化
  formatDate(times) {
    var date = new Date(times);
    var year = date.getFullYear(); //年份
    var month = date.getMonth() + 1; //月份
    var day = date.getDate(); //日
    return year + '-' + month + '-' + day
  }

  // 页面渲染前请求接口判断是否符合弹窗条件
  componentWillMount() {

    this.setState({
      visible: true
    })

    // let paramData = {
    //   action: "1",
    //   appid: "",
    //   param: {
    //     telephone: this.state.phoneNumber,
    //     type: "backlog",// 模拟请求数据是待办类型还是历史类型
    //     numsperpage: 10, // 模拟请求数据的行数
    //     page: 1, // 模拟请求数据的页面的下标
    //     begindate: "",
    //     enddate: "",
    //   }
    // }


    // let result = getAllMaterial(paramData);
    // result.then(res => {
    //   if (res) {
    //     let result = res.datas.queryresults;
    //     for (let i = 0; i < result.length; i++) {
    //       let vprocessstatus = result[i].vprocessstatus
    //       let dbilldate = result[i].dbilldate
    //       let currentDate = this.formatDate(Date.now());
    //       let dbDate = this.formatDate(dbilldate);
    //       // if (0 < vprocessstatus && vprocessstatus < 40 ) {
    //       this.setState({
    //         visible: true
    //       })
    //       // return
    //       // }
    //     }

    //   }
    // });

  }


  componentDidMount() {
    this.startCountdown();
  }

  startCountdown = () => {
    this.countdownInterval = setInterval(() => {
      const { countdown } = this.state;
      if (countdown > 0) {
        this.setState({ countdown: countdown - 1 });
      } else {
        this.setState({ countDownTextShow: "none" });
        this.stopCountdown();
      }
    }, 1000);
  };

  stopCountdown = () => {
    clearInterval(this.countdownInterval);
    this.setState({ isCounting: false });
  };

  handleClose = () => {
    this.setState({ visible: false });
  };

  render() {
    const { visible, countdown, isCounting, countDownTextShow } = this.state;
    return (
      <Modal
        title='用户须知'
        visible={visible}
        transparent
      >
        <div className="modal-content" dangerouslySetInnerHTML={{ __html: this.state.info }}>
          {/* {this.state.info} */}
        </div>
        <Button
          type="warning"
          disabled={isCounting}
          onClick={this.handleClose}
        >
          已阅读<span style={{ display: countDownTextShow }}> ({countdown})</span>
        </Button>
      </Modal>
    );
  }
}